<template>
	<div>
		<h2>当前缺陷信息</h2>
		<table class="form-table">
			<tr>
				<th style="width:80px;">位置：</th>
				<td></td>
				<th style="width:80px;">检测面：</th>
				<td></td>
				<th style="width:80px;">缺陷类型：</th>
				<td></td>
				<th style="width:80px;">面积</th>
				<td></td>
			</tr>
			<tr>
				<th>账号：</th>
				<td></td>
				<th>联号：</th>
				<td></td>
				<th>强度：</th>
				<td></td>
				<th></th>
				<td></td>
			</tr>
		</table>

		<div style="text-align:center;">
			<img :src="demoImage" alt="" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				demoImage: require('@/assets/images/demo_01.jpg'),
			}
		},
	}
</script>

<style scoped>
	.form-table {
		margin-bottom: 20px;
	}
</style>
